
export default {
  $validator: (value) => {
    // allow null
    if ( value === undefined || value === null || value === '') {
      return true;
    }
    // number so long is not valid. also covers us against DDOS
    if (value.length > 20) {
      return false;
    }

    const phoneRegex = /^(0\d{9}|\+[\d]{1,3}[\d\s-]{4,14}\d)$/;

    return phoneRegex.test(value);
  },
};
